export default {
  alts: {
    monthly: 'month',
    semi_annually: '6 months',
    yearly: 'year'
  }
}